import { Container } from './index'

interface Faq {
  question: string
  answer: string
}

const faqs: Faq[][] = [
  [
    {
      question: 'What is certified payroll?',
      answer:
        'Certified payroll is a detailed report required for government contracts that shows employee wages, hours worked, and ensures compliance with prevailing wage laws like the Davis-Bacon Act.'
    },
    {
      question: 'Do I need certified payroll for my government contract?',
      answer: 'Yes, if your contract is subject to the Davis-Bacon Act or other prevailing wage requirements, you must submit certified payroll reports to the contracting agency.'
    },
    {
      question: 'How often do I need to submit certified payroll reports?',
      answer:
        'Typically weekly, but this varies by contract. Check your contract specifications or contact your contracting officer for the exact requirements.'
    }
  ],
  [
    {
      question: 'What information is required in a certified payroll report?',
      answer:
        'Employee names, classifications, hours worked, wage rates, fringe benefits, and a statement of compliance signed by the employer or authorized representative.'
    },
    {
      question:
        'Can Simple CPRs help with Davis-Bacon Act compliance?',
      answer:
        'Yes, our software is specifically designed to help contractors comply with Davis-Bacon Act requirements and other prevailing wage laws.'
    },
    {
      question:
        'What if I make a mistake on my certified payroll report?',
      answer:
        'You can submit corrected reports, but it\'s important to correct errors promptly. Our software helps minimize errors with built-in validation and compliance checks.'
    }
  ],
  [
    {
      question: 'How do you ensure compliance with current wage rates?',
      answer:
        'We maintain an updated database of prevailing wage rates and automatically validate your payroll data against current requirements for your project location and classifications.'
    },
    {
      question: 'Can I export reports in the required format?',
      answer: 'Yes, our software generates reports in the standard WH-347 format and other formats required by government agencies.'
    },
    {
      question: 'What if I need help with a specific compliance issue?',
      answer:
        'Contact our support team for assistance with compliance questions. We can help you understand requirements and ensure your reports meet all necessary standards.'
    }
  ]
]

export function Faqs() {
  return (
    <section
      id="faq"
      aria-labelledby="faq-title"
      className="relative overflow-hidden py-20 sm:py-32"
    >
      <div 
        className="absolute inset-0"
        style={{ backgroundColor: 'var(--color-brand-primary)' }}
      />
      <Container className="relative">
        <div className="mx-auto max-w-2xl lg:mx-0">
          <h2
            id="faq-title"
            className="font-display text-3xl tracking-tight sm:text-4xl"
            style={{ color: 'var(--color-text-inverse)' }}
          >
            Frequently asked questions
          </h2>
          <p className="mt-4 text-lg tracking-tight" style={{ color: 'var(--color-text-inverse)' }}>
            Can't find the answer you're looking for? Contact our support team for help with certified payroll compliance questions.
          </p>
        </div>
        <ul
          role="list"
          className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-8 lg:max-w-none lg:grid-cols-3"
        >
          {faqs.map((column, columnIndex) => (
            <li key={columnIndex}>
              <ul role="list" className="flex flex-col gap-y-8">
                {column.map((faq, faqIndex) => (
                  <li key={faqIndex}>
                    <h3 className="font-display text-lg/7" style={{ color: 'var(--color-text-inverse)' }}>
                      {faq.question}
                    </h3>
                    <p className="mt-4 text-sm" style={{ color: 'var(--color-text-inverse)' }}>{faq.answer}</p>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </Container>
    </section>
  )
} 